import React from 'react';
import { useRecoilValue } from 'recoil';
import { CardBody } from '../../components/CardBody';
import { CardFooter } from '../../components/CardFooter';
import { isMobileState } from '../../recoil/selectors';
import { SuperPowerShortLanderMobile } from './SuperPowerShortLanderMobile';
import { HeroCallout } from '../HeroCallout';
import { WistiaPanel } from '../../components/WistiaPanel';
import { NewsIcons } from '../../product_detail/components/NewsIcons';
import { ShopAllColors } from '../components/ShopAllColors';
import { ProductFeatures } from '../components/ProductFeatures';
import { ProductComparison } from '../components/ProductComparison';
import { LanderTopHero } from '../components/LanderTopHero';
import { allProductsState } from '../../recoil/atoms';
import { ProductHandle } from '../../enums/ProductHandle.enum';
import { useLanderControls } from '../LanderContext';
import { useProductAssets } from '../../hooks/useProductAssets';

export const SuperPowerShortLander: React.FC = () => {
  const allProducts = useRecoilValue(allProductsState);
  const isMobile = useRecoilValue(isMobileState);
  const product = allProducts[ProductHandle.SuperPowerShort];
  const productAssets = useProductAssets(product);
  const wistiaVideoId = productAssets.videos[0]?.wistiaId;
  const padding = { padding: '56.25% 0 0 0' };
  const { scrollToProductSection } = useLanderControls();

  if (isMobile) {
    return <SuperPowerShortLanderMobile />;
  }

  return (
    <>
      <CardBody>
        <LanderTopHero
          maxHeroContainerHeight={'1066px'}
          heroImage={'desktop-superpowershort-lander-top-hero-1.jpg'}
          title={'SuperPower Short'}
          subTitle={'The next generation of shapewear.'}
        >
          <HeroCallout
            orderIndex={0}
            label="Waist stays up"
            labelColor={'black'}
            inlineStyles={{
              desktop: {
                left: `22.5%`,
                top: `8%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={1}
            label={
              <>
                Posture
                <br /> Support
              </>
            }
            titleStyles={{ lineHeight: '26px', marginTop: 12, textAlign: 'center' }}
            inlineStyles={{
              desktop: {
                left: `12%`,
                top: `14%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={2}
            label="Targeted Compression"
            labelColor={'black'}
            inlineStyles={{
              desktop: {
                left: `24%`,
                top: `20%`,
                flexDirection: 'row-reverse',
              },
            }}
          />
          <HeroCallout
            orderIndex={3}
            titleStyles={{ lineHeight: '26px', marginTop: 12, textAlign: 'center' }}
            label={
              <>
                Patented
                <br /> BoostBands
              </>
            }
            inlineStyles={{
              desktop: {
                left: `14%`,
                top: `60%`,
                flexDirection: 'column-reverse',
              },
            }}
          />
        </LanderTopHero>
        <NewsIcons />
        <ProductFeatures
          features={[
            {
              imgName: 'feature-sps-desktop-1.jpg',
              title: 'Doesn’t roll down',
              description: 'Flexible boning keeps the garment from rolling down.',
            },
            {
              imgName: 'feature-sps-desktop-2.jpg',
              title: 'Targeted compression',
              description: 'Varied levels of compression shape without squeezing.',
            },
            {
              imgName: 'feature-sps-desktop-3.jpg',
              title: 'Booty lifting',
              description: 'BoostBands shape thighs and lift the bottom.',
            },
          ]}
        />
        <ProductComparison
          onCtaClick={scrollToProductSection}
          competitorImage="superpowershort-competitor.png"
          honeyloveImage="superpowershort-honeylove.png"
          honeyloveText="Superpower Short"
          competitorText="Competitor"
          title={
            <>
              Innovation you <br /> can see.
            </>
          }
        />
        {wistiaVideoId && (
          <div style={{ padding: '50px 60px', paddingTop: 40, boxSizing: 'border-box' }}>
            <WistiaPanel videoId={wistiaVideoId} responsivePadding={padding} />
          </div>
        )}
        <ShopAllColors product={allProducts[ProductHandle.SuperPowerShort]} />
      </CardBody>
      <CardFooter />
    </>
  );
};

export default SuperPowerShortLander;
